import { Grid, TextField } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import * as Yup from "yup";
import { Formik, FormikHelpers } from "formik";
import { OUTCOMES } from "../../../constants";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

interface Values {
  barNum: string;
}

export const AttorneyBarNumScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      barNum: "",
    },
    schema: Yup.object().shape({
      barNum: Yup.number().required(),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        OUTCOMES.complete,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper title="What is your name?">
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={1}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.barNum && errors.barNum)}
                  fullWidth
                  helperText={touched.barNum && errors.barNum}
                  label="BAR number"
                  margin="normal"
                  name="barNum"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.barNum}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
